import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CoinStackFilledSvg = function CoinStackFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.262 4.976c0 .591-.405 1.138-1.094 1.585a9.6 9.6 0 0 0-2.276.703 6 6 0 0 0-.543.283c-.615.101-1.278.157-1.968.157-3.248 0-5.881-1.221-5.881-2.728C2.5 3.47 5.133 2.25 8.381 2.25s5.88 1.22 5.88 2.727M8.38 14.522v-.91c-1.774 0-3.447-.33-4.727-.924a6 6 0 0 1-1.154-.693v2.072c0 1.507 2.633 2.727 5.881 2.727zm.037-4.546c.055-.332.171-.636.328-.913a16 16 0 0 1-.365.004c-1.774 0-3.447-.33-4.727-.924A6 6 0 0 1 2.5 7.45v2.072c0 1.506 2.633 2.727 5.881 2.727V9.976zm7.201 3.182c3.248 0 5.881-1.22 5.881-2.727s-2.633-2.727-5.881-2.727-5.88 1.22-5.88 2.727 2.632 2.727 5.88 2.727m-4.727 4.985a6 6 0 0 1-1.154-.693v2.072c0 1.506 2.633 2.727 5.881 2.727s5.881-1.22 5.881-2.727v-2.073a6 6 0 0 1-1.154.693c-1.28.594-2.954.925-4.727.925s-3.447-.33-4.727-.924m9.454-4.546c-1.28.594-2.954.925-4.727.925s-3.447-.331-4.727-.925a6 6 0 0 1-1.154-.692v2.071c0 1.507 2.633 2.728 5.881 2.728s5.881-1.221 5.881-2.728v-2.072a6 6 0 0 1-1.154.693",
    clipRule: "evenodd"
  }));
};
export var CoinStackFilled = function CoinStackFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CoinStackFilledSvg
  }));
};